jQuery(document).ready(function ($) {
	if ($('#team_slider').length) {
		$('#team_slider').slick({
			centerMode: true,
			slidesToShow: 5,
			dots: true,
			arrows: false
		});

		$('#testimonials_slider').slick({
			dots: true,
			arrows: false
		});
	}
});

// menu service hover
jQuery(document).ready(function ($) {
	$('#menu-item-74, .services_nav').mouseenter(function () {
		$('.services_nav').addClass('open');
	});
	$('#menu-item-74, .services_nav').mouseleave(function () {
		$('.services_nav').removeClass('open');
	});
	$('.google').mouseenter(function () {
		$('.google-text').addClass('show');
	});
	$('.google').mouseleave(function () {
		$('.google-text').removeClass('show');
	});
});

// menu service click
jQuery(document).ready(function ($) {
	$('#menu-item-254 a').click(function (e) {
		e.preventDefault();

		$('#mob_nav_wrapper').addClass('slide');
		$('#mob_services_wrapper').addClass('slide');
	});
});

// burger icon click
jQuery(document).ready(function ($) {
	$('#burger_icon').click(function () {
		if ($('#mob_nav_wrapper').hasClass('slide')) {
			setTimeout(function () {
				$('#mob_nav_wrapper').removeClass('slide');
			}, 1000);
		}

		$(this).toggleClass('open');
		$('#mob_nav_wrapper').toggleClass('open');
	});
});

// back button click
jQuery(document).ready(function ($) {
	$('#back_btn').click(function () {
		$('#mob_nav_wrapper').removeClass('slide');
	});
});

// vocher pre populate
jQuery(document).ready(function ($) {
	if ($('.datadiv').length) {
		//split data on , into arrays
		number = $('.datadiv').data('number').split(',');
		myname = $('.datadiv').data('myname').split(',');
		email = $('.datadiv').data('email').split(',');
		school = $('.datadiv').data('school').split(',');
		myCode = $('.datadiv').data('mycode');
		console.log(myCode);

		function update() {
			thisval = $('#voucher-number').val();
			index = number.indexOf(thisval);
			$('#form_name').val(myname[index]);
			$('#voucher-email').val(email[index]);
			$('#school').val(school[index]);
		}
		if (myCode) {
			$('#voucher-number').val(myCode);
			update();
		}
		//auto populate
		$('#voucher-number').keyup(function () {
			update();
		})

	}
});


jQuery(document).ready(function ($) {
	//custom radio 
	$('.wpcf7-list-item-label').click(function () {
		console.log('clicked2');
		$('.active').removeClass("active");
		$(this).addClass("active");
	})

});